import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerMain = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 63px;
  padding: 60px 20px;
  width: 100%;
  background-color: ${Variables.colorWhite};
`;

export const Back = styled.div`
  align-self: flex-start;
  margin-bottom: 20px;
  padding: 5px 10px;
  width: 70px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  cursor: pointer;

  & :hover {
    opacity: 0.7;
  }
`;

export const Title = styled.p`
  font-size: 40px;
  font-weight: 700;
  color: ${Variables.colorBlackDark};
`;

export const Description = styled.p`
  margin: 20px 0;
  width: 40%;
  text-align: center;
  font-size: 20px;
  font-weight: 500;

  @media (max-width: 1440px) {
    width: 80%;
  }

  @media (max-width: ${Variables.maxLaptops}) {
    width: 80%;
    font-size: 15px;
  }

  @media (max-width: ${Variables.maxTablet}) {
    width: 100%;
    font-size: 15px;
  }
`;

export const ContainerImage = styled.div`
  width: 60%;

  @media (max-width: 1440px) {
    width: 80%;
  }

  @media (max-width: ${Variables.maxLaptops}) {
    width: 80%;
  }

  @media (max-width: ${Variables.maxTablet}) {
    width: 100%;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
